import { useEffect } from "react";

const DEFAULT_OG_IMAGE = "https://loansalaah.com/og-image.jpg";

function setMeta(selector, attr, value) {
  if (!value) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const match = selector.match(/\[(name|property)="(.+?)"\]/);
    if (match) el.setAttribute(match[1], match[2]);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

export function useSEO({ title, description, image, type, jsonLd }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      setMeta('meta[property="og:title"]', "content", title);
      setMeta('meta[name="twitter:title"]', "content", title);
    }
    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
      setMeta('meta[name="twitter:description"]', "content", description);
    }
    // Always set so navigating away from an article restores the default card.
    setMeta('meta[property="og:image"]', "content", image || DEFAULT_OG_IMAGE);
    setMeta('meta[name="twitter:image"]', "content", image || DEFAULT_OG_IMAGE);
    setMeta('meta[property="og:type"]', "content", type || "website");
  }, [title, description, image, type]);

  useEffect(() => {
    const id = "route-jsonld";
    const existing = document.getElementById(id);
    if (!jsonLd) {
      if (existing) existing.remove();
      return undefined;
    }
    const el = existing || document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    el.textContent = JSON.stringify(jsonLd);
    if (!existing) document.head.appendChild(el);
    return () => {
      const s = document.getElementById(id);
      if (s) s.remove();
    };
  }, [jsonLd]);
}
